(function () {
  const roots = document.querySelectorAll("[data-banana-bonanza]");

  roots.forEach(function (root) {
    const reveals = root.querySelectorAll("[data-bb-reveal]");

    if ("IntersectionObserver" in window && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12 }
      );

      reveals.forEach(function (element) {
        observer.observe(element);
      });
    } else {
      reveals.forEach(function (element) {
        element.classList.add("is-visible");
      });
    }

    const mainImage = root.querySelector(".bb-pdp__main-image");
    const mainMedia = root.querySelector(".bb-pdp__main-media");
    const thumbnails = Array.from(root.querySelectorAll("[data-bb-thumb]"));

    const showProductImage = function (thumb) {
        if (!mainImage || !thumb.dataset.image) return;

        thumbnails.forEach(function (item) {
          item.classList.toggle("is-active", item === thumb);
        });

        mainImage.style.opacity = "0";
        window.setTimeout(function () {
          mainImage.src = thumb.dataset.image;
          mainImage.removeAttribute("srcset");
          if (thumb.dataset.imageAlt) mainImage.alt = thumb.dataset.imageAlt;
          mainImage.style.opacity = "1";
        }, 140);

        thumb.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    };

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        showProductImage(thumb);
      });
    });

    if (mainMedia && thumbnails.length > 1) {
      let touchStartX = 0;
      let touchStartY = 0;

      mainMedia.addEventListener("touchstart", function (event) {
        const touch = event.touches && event.touches[0];
        if (!touch) return;

        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });

      mainMedia.addEventListener("touchend", function (event) {
        const touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;

        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;

        const activeIndex = Math.max(0, thumbnails.findIndex(function (thumb) {
          return thumb.classList.contains("is-active");
        }));
        const nextIndex = deltaX < 0
          ? Math.min(thumbnails.length - 1, activeIndex + 1)
          : Math.max(0, activeIndex - 1);

        if (nextIndex !== activeIndex) showProductImage(thumbnails[nextIndex]);
      }, { passive: true });
    }

    const price = root.querySelector("[data-bb-price]");
    const comparePrice = root.querySelector("[data-bb-compare-price]");
    const variantInput = root.querySelector("[data-bb-variant-input]");
    const addButton = root.querySelector("[data-bb-add]");
    const addLabel = root.querySelector("[data-bb-add-label]");
    const availableLabel = addLabel ? addLabel.textContent.trim() : "Add to cart";
    const soldOutLabel = "Sold out";

    root.querySelectorAll("[data-bb-variant]").forEach(function (button) {
      button.addEventListener("click", function () {
        const isAvailable = button.dataset.available === "true";
        const compare = button.dataset.compare || "";

        root.querySelectorAll("[data-bb-variant]").forEach(function (item) {
          item.classList.toggle("is-active", item === button);
        });

        if (variantInput) variantInput.value = button.dataset.id || "";
        if (price) price.textContent = button.dataset.price || "";
        if (comparePrice) {
          comparePrice.textContent = compare;
          comparePrice.hidden = !compare;
        }
        if (addButton) addButton.disabled = !isAvailable;
        if (addLabel) addLabel.textContent = isAvailable ? availableLabel : soldOutLabel;
      });
    });

    root.querySelectorAll("[data-bb-quantity]").forEach(function (stepper) {
      const input = stepper.querySelector("input");
      if (!input) return;

      stepper.querySelectorAll("[data-bb-quantity-action]").forEach(function (button) {
        button.addEventListener("click", function () {
          const minimum = Number(input.min || 1);
          const current = Number(input.value || minimum);
          input.value = String(button.dataset.bbQuantityAction === "increase" ? current + 1 : Math.max(minimum, current - 1));
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });

    const reels = root.querySelector("[data-bb-reels]");
    if (reels) {
      const scrollReels = function (direction) {
        const card = reels.querySelector(".bb-video-card");
        const gap = Number.parseFloat(window.getComputedStyle(reels).columnGap || "16");
        const distance = card ? card.getBoundingClientRect().width + gap : reels.clientWidth * 0.8;
        reels.scrollBy({ left: direction * distance, behavior: "smooth" });
      };

      const previousReel = root.querySelector("[data-bb-reels-prev]");
      const nextReel = root.querySelector("[data-bb-reels-next]");
      if (previousReel) previousReel.addEventListener("click", function () { scrollReels(-1); });
      if (nextReel) nextReel.addEventListener("click", function () { scrollReels(1); });
    }

    root.querySelectorAll(".bb-video-card__media").forEach(function (media) {
      const video = media.querySelector("video");
      const playButton = media.querySelector("[data-bb-video-play]");

      if (!video || !playButton) return;

      const setPlayingState = function (isPlaying) {
        media.classList.toggle("is-playing", isPlaying);
        playButton.hidden = isPlaying;
      };

      playButton.addEventListener("click", function () {
        video.play().then(function () {
          setPlayingState(true);
        }).catch(function () {
          setPlayingState(false);
        });
      });

      video.addEventListener("play", function () {
        setPlayingState(true);
      });

      video.addEventListener("pause", function () {
        if (!video.ended) setPlayingState(false);
      });

      video.addEventListener("ended", function () {
        setPlayingState(false);
      });
    });

    const mobileCta = root.querySelector(".bb-mobile-cta");
    const productRoot = root.querySelector("[data-bb-product-root]");
    const siteFooter = document.querySelector(".footer, .preview-footer");

    if (mobileCta && productRoot) {
      let ctaTicking = false;
      const updateMobileCta = function () {
        const productHasPassed = productRoot.getBoundingClientRect().bottom < 0;
        const footerIsNear = siteFooter && siteFooter.getBoundingClientRect().top < window.innerHeight;
        mobileCta.classList.toggle("is-visible", productHasPassed && !footerIsNear);
        ctaTicking = false;
      };
      const requestCtaUpdate = function () {
        if (ctaTicking) return;
        ctaTicking = true;
        window.requestAnimationFrame(updateMobileCta);
      };

      updateMobileCta();
      window.addEventListener("scroll", requestCtaUpdate, { passive: true });
      window.addEventListener("resize", requestCtaUpdate);
    }
  });
})();
